const create = require('./create');
const memoize = require('./memoize');
const multiArrayCache = require('./multiArrayCache');
const multiRedisCache = require('./multiRedisCache');

module.exports = {
  create,
  memoize,
  multiArrayCache,
  multiRedisCache,
};
